/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {BundleInformationTableColumnEnum} from '../models/bundle-information-table-column.enum';
import {TableHeaderEntryModel} from '../../../shared/table/models/table-header-entry.model';
import * as FinancialNumberDataPipe from '../../util/financial-number/pipe/financial-number-data-pipe';

const bundleInformationTableHeaders: {
    totalValue: TableHeaderEntryModel<BundleInformationTableColumnEnum>;
    additionalCriterion: TableHeaderEntryModel<string>;
    additionalValue: TableHeaderEntryModel<string>;
} = {
    totalValue: {
        code: BundleInformationTableColumnEnum.TOTAL_VALUE,
        name: 'Total amount',
        sortable: false,
        widthWeight: 20,
        hasTextAlignRight: true,
        dataPipe: FinancialNumberDataPipe.financialNumberPipe,
        hasCopyPaste: true
    },
    additionalCriterion: {
        code: null,
        name: null,
        sortable: false,
        widthWeight: 60,
        hasCopyPaste: true
    },
    additionalValue: {
        code: null,
        name: null,
        sortable: false,
        widthWeight: 20,
        hasTextAlignRight: true,
        dataPipe: FinancialNumberDataPipe.financialNumberPipe,
        hasCopyPaste: true
    }
};

export default bundleInformationTableHeaders;
